/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import CreateNewProfessionalModal from 'DesignSystem/CreateNewProfessionalModal/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let profilePatientIdValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'id',
})
  return (<React.Fragment
>
<CreateNewProfessionalModal
  viewPath={`${viewPath}/CreateNewProfessionalModal`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onSave={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 onCancel={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../Search/Content'))}
 data="profile_patient.id"
 patientId={profilePatientIdValueData}
/>
{children}
</React.Fragment>)
}